module.exports = __webpack_public_path__ + "img/send.fc28cd78.svg";